document.addEventListener('DOMContentLoaded', function (_event) {
  const modalOverlay = document.querySelector('.modal-overlay');
  if (modalOverlay) {
    const modal = modalOverlay.querySelector('.modal');
    if (modal) {
      const modalContent = modal.querySelector('.placeholder');
      const openModal = document.querySelector('.openModal');
      if (openModal && modalContent) {
        const video = document.querySelector('.video-wrapper iframe').cloneNode(true);
        openModal.addEventListener('click', () => {
          modalOverlay.classList.add('visible', 'video-module');
          modal.style.background = 'none';
          modal.style.boxShadow = 'none';
          if (video.dataset.full) {
            video.src = `https://player.vimeo.com/video/${video.dataset.full}`;
          } else {
            video.src = video.src.split('?')[0];
          }
          video.style = '';
          modalContent.innerHTML = '';
          modalContent.appendChild(video);
        });
      }
    }
  }
  // AB TEST - Special Offer X Card
  const videoSection = document.querySelector('.video-section');
  if (videoSection && (window.location.pathname === '/fr/payment-methods/card-va/x-card-va' || window.location.pathname === '/it/payment-methods/card-va/x-card-va')) {
    const url = window.location.pathname;
    AddMentionBelowCta(videoSection, url);
  }
});

const AddMentionBelowCta = (videoSection, url) => {
  const btns = videoSection.querySelector('.btns-container');
  const pMention = document.createElement('p');
  pMention.className = 'mention-below-cta mt-16 text-14 with-links text-center md:text-left md:ml-0';
  if (url.includes('/it/')) {
    pMention.innerHTML = "Offerta esclusiva: carta X gratis per 2 mesi con il codice sconto QONTO2X, per i piani Basic, Smart e Premium. <a href='https://qonto-assets.s3.eu-central-1.amazonaws.com/documents/QONTO-OFFERTASPECIAL-IT.pdf' target='_blank'>Leggi le condizioni dell’offerta</a>"
  } else {
    pMention.innerHTML = "Offre exclusive : 2 mois offerts sur la Carte X avec le code QONTO2X sur les forfaits Basic, Smart et Premium. <a href='https://qonto.com/documents/QONTO-OFFRESPECIALE-FR.pdf' target='_blank'>Voir les conditions de l’offre</a>"
  }
  btns.appendChild(pMention);
}
